import { Switch } from '@mui/material'
import { useObservableEagerState } from 'observable-hooks'
import { useCallback } from 'react'

import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { MetalworksAnalytics, analyticsService } from '../systems/analytics'
import { anchorPointsService } from '../systems/anchor-points-service'

export const AnchorPointsToggle = () => {
  const { visible: anchorPointsVisible } = useObservableEagerState(anchorPointsService.state$)

  const handleAnchorPointsToggle = useCallback(() => {
    const newVisibleState = !anchorPointsVisible

    anchorPointsService.setVisible(newVisibleState)
    analyticsService.push(MetalworksAnalytics.FeatureAnchorPointsToggled(newVisibleState))
  }, [anchorPointsVisible])

  return (
    <PropertyContainer.Item
      title="Adjust Anchor Points"
      action={
        <Switch
          inputProps={{ 'aria-label': 'toggle anchor points visibility' }}
          checked={anchorPointsVisible}
          onChange={handleAnchorPointsToggle}
        />
      }
    />
  )
}
